var _style, _g, _g2, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFtm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 590.5 193.5",
    style: {
      enableBackground: "new 0 0 590.5 193.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#853C3C;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#D24A43;}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.5,37.4H255v-2.1c-1.7-0.1-3.2-0.3-4.5-0.9c-1.3-0.5-2.4-1.2-3.3-2.1c-0.9-0.9-1.6-1.9-2-3c-0.5-1.2-0.7-2.4-0.7-3.7 v-3.6c0-1.3,0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.1,2.1-3c0.9-0.9,2-1.6,3.3-2.1c1.3-0.5,2.8-0.8,4.4-0.9v-1.1h3.5v1.1 c1.6,0,3.1,0.3,4.4,0.9c1.3,0.5,2.4,1.2,3.3,2.1c0.9,0.9,1.6,1.9,2.1,3c0.5,1.1,0.7,2.3,0.7,3.6v3.5c0,1.3-0.2,2.6-0.7,3.7 c-0.5,1.2-1.1,2.2-2,3.1c-0.9,0.9-2,1.6-3.3,2.1c-1.3,0.5-2.8,0.8-4.5,0.9V37.4z M248,25.4c0,1,0.2,2,0.5,2.8 c0.3,0.8,0.8,1.5,1.4,2.1c0.6,0.6,1.3,1,2.2,1.3c0.8,0.3,1.8,0.5,2.8,0.5V15.5c-1,0-2,0.2-2.8,0.5c-0.8,0.3-1.6,0.8-2.2,1.4 c-0.6,0.6-1.1,1.3-1.4,2.1c-0.3,0.8-0.5,1.7-0.5,2.7V25.4z M265.5,22.2c0-1-0.2-1.9-0.5-2.7c-0.3-0.8-0.8-1.5-1.4-2.1 c-0.6-0.6-1.3-1-2.2-1.4c-0.8-0.3-1.8-0.5-2.8-0.5V32c1,0,1.9-0.2,2.8-0.5c0.9-0.3,1.6-0.8,2.2-1.3c0.6-0.6,1.1-1.3,1.4-2.1 c0.3-0.8,0.5-1.7,0.5-2.8V22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,37.4V11.4h17.3v3.2h-13.8v8.2h11.8V26h-11.8v8.3h13.8v3.1H272.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,34.1c0.6-0.4,1.1-0.9,1.5-1.6c0.4-0.6,0.8-1.4,1.1-2.3c0.3-1,0.5-2.1,0.7-3.5c0.2-1.4,0.3-3,0.4-5l0.4-10.3H315 l0,22.8h2.1V43h-3.4v-5.6H296V43h-3.4v-8.8H294.5z M301.8,14.6l-0.4,7.4c-0.1,1.7-0.2,3.1-0.3,4.4c-0.1,1.3-0.2,2.4-0.4,3.3 c-0.2,1-0.4,1.8-0.7,2.5c-0.3,0.7-0.7,1.4-1.1,1.9h12.6V14.6H301.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,37.4V11.4h17.3v3.2h-13.8v8.2h11.8V26h-11.8v8.3h13.8v3.1H320.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,19.2c0,0.9-0.2,1.8-0.5,2.8c-0.3,0.9-0.8,1.7-1.4,2.5c-0.6,0.7-1.4,1.3-2.3,1.8c-0.9,0.5-1.9,0.7-3.1,0.7h-7.3v10.4 H341V11.4h10.8c1.3,0,2.3,0.2,3.3,0.7c0.9,0.5,1.7,1.1,2.3,1.8c0.6,0.7,1.1,1.6,1.4,2.5C358.9,17.3,359.1,18.3,359.1,19.2z  M355.7,19.2c0-1.4-0.4-2.5-1.3-3.3c-0.9-0.8-2-1.2-3.3-1.2h-6.6v9.1h6.6c1.4,0,2.5-0.4,3.3-1.2C355.2,21.7,355.7,20.6,355.7,19.2z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,37.4l-2-5.8H364l-2,5.8h-3.6l9-25.9h3.5l9.1,25.9H376.4z M369.1,16.2l-1.9,6l-2.1,6.2h8.1l-2.1-6.2l-1.9-6H369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.7,37.4h-17.9V11.4h3.5v22.8h12.1V11.4h3.5v22.7l2.1,0V43h-3.4V37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.2,17.3l-3.8,6l-9.1,14.1h-3.3V11.4h3.5v19.8h0.3l3.3-5.2l9.4-14.6h3.3v25.9h-3.5V17.3H423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1,19.2c0-1.1,0.2-2,0.5-3c0.3-0.9,0.8-1.8,1.4-2.5c0.6-0.7,1.4-1.3,2.3-1.7c0.9-0.4,2-0.6,3.2-0.6h10.7v25.9h-3.5 V26.2h-5.2c-0.4,0-0.9,0.1-1.3,0.2c-0.5,0.1-0.9,0.3-1.3,0.6c-0.4,0.3-0.8,0.7-1.1,1.2c-0.4,0.5-0.7,1.2-0.9,2l-2,7.1h-3.5l2.1-7.5 c0.3-1.1,0.7-1.9,1.1-2.7c0.4-0.7,1-1.3,1.8-1.7c-1.5-0.5-2.6-1.2-3.3-2.4C431.5,22.1,431.1,20.7,431.1,19.2z M434.4,19.2 c0,1.5,0.5,2.5,1.4,3.2c0.9,0.6,2.1,0.9,3.5,0.9h6.5v-8.7h-6.5c-1.6,0-2.7,0.4-3.6,1.2C434.8,16.6,434.4,17.7,434.4,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7,73.8v36.7h-8.9V73.8H243v-8h32.5v8H263.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1,65.9c2.2,0,4.1,0.4,5.7,1.3c1.6,0.8,2.9,1.9,4,3.3c1.1,1.3,1.8,2.8,2.3,4.5c0.5,1.7,0.7,3.3,0.7,4.9 c0,1.6-0.3,3.3-0.9,4.9c-0.6,1.6-1.4,3.1-2.5,4.5c-1.1,1.3-2.5,2.4-4.1,3.3c-1.6,0.8-3.5,1.3-5.5,1.3h-10.8v16.8h-8.9V65.9H300.1z  M289.1,85.7h9.1c2,0,3.6-0.6,4.6-1.7c1-1.1,1.6-2.5,1.6-4.2c0-1.7-0.5-3.2-1.6-4.3c-1.1-1.1-2.6-1.7-4.6-1.7h-9.1V85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,81.4l-4.4,6.8c-0.5,0.8-1.2,1.8-1.9,3c-0.8,1.2-1.6,2.5-2.5,3.9c-0.9,1.4-1.8,2.8-2.8,4.3c-1,1.5-1.9,2.9-2.8,4.3 c-0.9,1.4-1.7,2.7-2.5,3.9c-0.8,1.2-1.4,2.2-1.9,3h-8V65.9h8.9v29.3h0.3l9.3-14.6l9.5-14.8h8.1v44.6h-8.9V81.4H344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,101.3h-15.5l-2.9,9.2h-9.5L374,65.9h9.1l15.5,44.6h-9.6L386.2,101.3z M373.1,93.8h10.8l-1.8-5.7l-3.5-11.8h-0.3 l-3.4,11.6L373.1,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,73.8v36.7h-8.9V73.8h-11.8v-8h32.5v8H416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.5,73.8v11.8c0,3.7-0.2,7.1-0.6,10.1c-0.4,3-1.2,5.6-2.3,7.8c-1.1,2.2-2.7,4-4.7,5.3c-2,1.3-4.6,2.2-7.7,2.7l-1.9-7.3 c1.9-0.6,3.3-1.4,4.5-2.3c1.1-0.9,2-2.2,2.6-3.6c0.6-1.5,1-3.2,1.2-5.2c0.2-2,0.3-4.4,0.3-7.2V65.9h29.4v44.6h-9V73.8H443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.9,96.2c0,2.4-0.5,4.5-1.4,6.3c-0.9,1.8-2.1,3.3-3.7,4.6c-1.6,1.3-3.4,2.2-5.5,2.8c-2.1,0.6-4.3,0.9-6.6,0.9 c-2.3,0-4.5-0.3-6.6-0.9c-2.1-0.6-3.9-1.6-5.5-2.8c-1.6-1.3-2.8-2.8-3.7-4.6c-0.9-1.8-1.4-3.9-1.4-6.3V79.8c0-2.4,0.5-4.5,1.4-6.3 c0.9-1.8,2.2-3.3,3.8-4.5c1.6-1.2,3.4-2.1,5.5-2.7c2.1-0.6,4.2-0.9,6.4-0.9c2.2,0,4.3,0.3,6.4,1c2.1,0.6,3.9,1.6,5.5,2.8 c1.6,1.2,2.9,2.8,3.8,4.6c0.9,1.8,1.4,3.9,1.4,6.3V96.2z M496.1,81.7c0-1.5-0.2-2.7-0.7-3.7c-0.5-1-1.1-1.8-1.9-2.5 c-0.8-0.6-1.7-1.1-2.6-1.4c-1-0.3-2-0.5-3-0.5c-1,0-2.1,0.2-3,0.5c-1,0.3-1.9,0.8-2.7,1.4c-0.8,0.6-1.4,1.5-1.9,2.5 c-0.5,1-0.7,2.3-0.7,3.7v13c0,1.5,0.2,2.7,0.7,3.8c0.5,1,1.1,1.9,1.9,2.5c0.8,0.6,1.7,1.1,2.7,1.4c1,0.3,2,0.4,3,0.4 c1,0,2-0.1,3-0.4c1-0.3,1.8-0.7,2.6-1.4c0.8-0.6,1.4-1.5,1.9-2.5c0.5-1,0.7-2.3,0.7-3.8V81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.7,110.5V91.8h-16.4v18.6h-8.9V65.9h8.9v18h16.4v-18h9v44.6H536.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.2,101.3h-15.5l-2.9,9.2h-9.5l15.7-44.6h9.1l15.5,44.6h-9.6L578.2,101.3z M565,93.8h10.8l-1.7-5.7l-3.5-11.8h-0.3 l-3.4,11.6L565,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,149.2l-4.1,8.2l-5,9.6h-6.4l-5-9.4l-4.3-8.4h-0.3v24h-8.9v-44.6h8.2l8,15.7l5.4,11h0.4l5.4-11.3l7.6-15.5h8.2v44.6 h-8.9v-24H280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.9,158.9c0,2.4-0.5,4.5-1.4,6.3c-0.9,1.8-2.1,3.3-3.7,4.6c-1.6,1.3-3.4,2.2-5.5,2.8c-2.1,0.6-4.3,0.9-6.6,0.9 c-2.3,0-4.5-0.3-6.6-0.9c-2.1-0.6-3.9-1.6-5.5-2.8c-1.6-1.3-2.8-2.8-3.7-4.6c-0.9-1.8-1.4-3.9-1.4-6.3v-16.4c0-2.4,0.5-4.5,1.4-6.3 c0.9-1.8,2.2-3.3,3.8-4.5c1.6-1.2,3.4-2.1,5.5-2.7c2.1-0.6,4.2-0.9,6.4-0.9c2.2,0,4.3,0.3,6.4,1c2.1,0.6,3.9,1.6,5.5,2.8 c1.6,1.2,2.9,2.8,3.8,4.6c0.9,1.8,1.4,3.9,1.4,6.3V158.9z M321,144.3c0-1.5-0.2-2.7-0.7-3.7c-0.5-1-1.1-1.8-1.9-2.5 c-0.8-0.6-1.7-1.1-2.6-1.4c-1-0.3-2-0.5-3-0.5c-1,0-2.1,0.2-3,0.5c-1,0.3-1.9,0.8-2.7,1.4c-0.8,0.6-1.4,1.5-1.9,2.5 c-0.5,1-0.7,2.3-0.7,3.7v13c0,1.5,0.2,2.7,0.7,3.8c0.5,1,1.1,1.9,1.9,2.5c0.8,0.6,1.7,1.1,2.7,1.4c1,0.3,2,0.4,3,0.4 c1,0,2-0.1,3-0.4c1-0.3,1.8-0.7,2.6-1.4c0.8-0.6,1.4-1.5,1.9-2.5c0.5-1,0.7-2.3,0.7-3.8V144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,139.3c-1.4-1.2-2.9-2-4.5-2.4c-1.6-0.5-3.2-0.7-4.7-0.7c-1,0-2,0.1-3,0.4c-1,0.3-1.9,0.7-2.7,1.4 c-0.8,0.6-1.4,1.5-1.9,2.5c-0.5,1-0.7,2.3-0.7,3.8v13c0,1.5,0.2,2.7,0.7,3.7c0.5,1,1.1,1.8,1.9,2.5c0.8,0.6,1.7,1.1,2.7,1.4 c1,0.3,2,0.5,2.9,0.5c1.5,0,3-0.2,4.6-0.6c1.5-0.4,3.1-1.3,4.6-2.5l4.2,6.9c-1.6,1.4-3.6,2.5-6,3.2c-2.4,0.8-4.9,1.2-7.5,1.2 c-2.1,0-4.2-0.3-6.2-0.9c-2-0.6-3.8-1.5-5.4-2.7c-1.6-1.2-2.9-2.7-3.9-4.5c-1-1.8-1.5-3.9-1.5-6.3v-16.7c0-2.4,0.5-4.5,1.5-6.2 c1-1.8,2.2-3.3,3.8-4.5c1.6-1.2,3.4-2.1,5.4-2.7c2-0.6,4.1-0.9,6.2-0.9c2.6,0,5.1,0.3,7.5,1c2.4,0.7,4.5,1.8,6.2,3.3L362.1,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,173.1v-44.6h8.9v17.9h4.5c0.9,0,1.7-0.1,2.4-0.2c0.8-0.2,1.4-0.4,2.1-0.8c0.6-0.4,1.2-1,1.7-1.7 c0.5-0.8,0.9-1.7,1.3-2.9l3.9-12.2h9.1l-4,13c-0.7,2.2-1.6,4-2.7,5.5c-1.1,1.5-2.3,2.4-3.7,2.9c1.9,0.6,3.3,1.7,4.3,3.2 c1,1.5,1.9,3.4,2.5,5.6l4.3,14.4h-9.6l-3.7-13c-0.3-1.2-0.8-2.2-1.3-3c-0.5-0.8-1.1-1.4-1.7-1.8c-0.6-0.4-1.3-0.7-2.1-0.9 c-0.8-0.2-1.6-0.2-2.5-0.2h-4.9v18.8H371.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,159.9c0,1.8-0.3,3.5-0.8,5.1c-0.6,1.6-1.4,3-2.5,4.2c-1.1,1.2-2.4,2.2-4,2.9c-1.6,0.7-3.5,1.1-5.6,1.1h-20.9v-44.6 h20.1c2.2,0,4.2,0.3,5.8,1c1.6,0.6,3,1.5,4,2.7c1.1,1.1,1.8,2.4,2.4,3.9c0.5,1.5,0.8,3,0.8,4.6c0,1.6-0.4,3.3-1.3,5.1 c-0.9,1.7-2.3,3.1-4.2,4c1.1,0.5,2,1.2,2.8,2c0.8,0.8,1.4,1.7,1.9,2.6c0.5,0.9,0.9,1.9,1.2,2.8C445.2,158.1,445.4,159,445.4,159.9z  M435.5,141.5c0-1.6-0.5-2.9-1.5-3.8c-1-0.9-2.5-1.3-4.6-1.3h-9v9.8h9.1c1.9,0,3.3-0.4,4.3-1.3C435,144.1,435.5,143,435.5,141.5z  M436,159.6c0-1.7-0.5-3.1-1.6-4.2c-1.1-1.1-2.6-1.6-4.5-1.6h-9.5v11.3h9.5c2,0,3.5-0.5,4.5-1.5C435.5,162.7,436,161.3,436,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.1,173.1v-44.6h8.9v17h10.3c2.2,0,4.2,0.3,5.9,1c1.7,0.7,3.2,1.6,4.4,2.9c1.2,1.2,2.1,2.7,2.8,4.3c0.6,1.7,1,3.5,1,5.5 c0,1.6-0.3,3.3-0.8,4.9c-0.5,1.6-1.3,3.1-2.4,4.4c-1.1,1.3-2.5,2.4-4.2,3.2c-1.7,0.8-3.8,1.3-6.3,1.3H451.1z M459.9,165.2h9.2 c2,0,3.6-0.6,4.8-1.7c1.2-1.1,1.8-2.5,1.8-4.2c0-1.7-0.6-3.1-1.8-4.2c-1.2-1.1-2.8-1.6-4.8-1.6h-9.1V165.2z M497.4,128.5v44.6h-8.9 v-44.6H497.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.1,80.3c-8,9.1-8.4,17.4-8.4,26.6v41.5l-9,5.1l-8.2-5.1v-41.5c0-9.2-0.4-17.5-8.5-26.6v63.8l-16.2-11.3 V62.5h21.9c4.7,5,8.6,10.4,11.3,18.5c2.6-8,6.6-13.5,11.3-18.5h21.9v70.3l-16.2,11.3V80.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.8507,
    y1: 153.5968,
    x2: 89.8507,
    y2: 62.4853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4B1200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8545,
    style: {
      stopColor: "#853C3C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,153.6l-8.2-5.1v-41.5c0-9.2-0.5-17.5-8.4-26.6L87,62.5c4.7,5,8.6,10.4,11.3,18.5L98,153.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.9767,
    y1: 144.1212,
    x2: 72.9767,
    y2: 62.4853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#853C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C231C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,80.3v63.8l-16.2-11.3V62.5L81.1,80.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.3798,
    y1: 144.1212,
    x2: 123.3798,
    y2: 62.4853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#853C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C231C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.4,62.5v70.3l-16.1,11.3V80.3L131.4,62.5z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "98,42.7 99.7,48 105.3,48 100.7,51.3 102.5,56.7 98,53.4 93.4,56.7 95.1,51.3 90.6,48 96.2,48  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "73.6,42.8 75.3,48.1 81,48.1 76.4,51.4 78.1,56.8 73.6,53.5 69,56.8 70.8,51.4 66.2,48.1 71.8,48.1  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "122.3,42.7 124.1,48 129.7,48 125.1,51.3 126.9,56.7 122.3,53.4 117.8,56.7 119.5,51.3 114.9,48  120.6,48  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.9069,
    y1: 144.0743,
    x2: 76.9069,
    y2: 70.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C231C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#853C3C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81,144.1l-8.2-5.8V70.5l8.1,9.2L81,144.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.2006,
    y1: 144.0743,
    x2: 119.2006,
    y2: 70.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C231C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#853C3C"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.2,79.8l8.1-9.2v67.8l-8.2,5.8L115.2,79.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.1705,
    y1: 169.7071,
    x2: 98.1705,
    y2: 18.9132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D24A43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#853C3C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.1,169.7c-2,0-3.8-1.3-4.3-3.3c-0.6-2.4,0.8-4.8,3.1-5.5c11.4-3.1,21.8-9.1,30.2-17.5 c15.9-16,22.8-38.7,18.5-60.8c-7.2-36.7-42.8-60.6-79.5-53.5c-36.6,7.2-60.6,42.8-53.4,79.5c4.9,25,23.2,45,47.6,52.1 c2.4,0.7,3.7,3.2,3,5.5c-0.7,2.4-3.2,3.7-5.5,3.1c-27.7-8-48.4-30.6-53.9-58.9c-8.1-41.5,19-81.8,60.5-89.9 c41.5-8.1,81.8,19,90,60.5c4.9,25-2.9,50.8-21,68.9c-9.4,9.5-21.3,16.3-34.2,19.8C117.9,169.7,117.5,169.7,117.1,169.7L117.1,169.7 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.1721,
    y1: 193.5439,
    x2: 98.1721,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    style: {
      stopColor: "#853C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D24A43"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.1,193.5c-46.8,0-88.3-33.6-96.7-81.3c-5.6-32.2,5.1-64.9,28.6-87.6C42.4,12.8,57.7,4.3,74.3,0.1 c2.4-0.6,4.8,0.9,5.4,3.3c0.6,2.4-0.9,4.8-3.3,5.4c-15.1,3.8-29,11.5-40.2,22.3c-21.4,20.6-31.1,50.4-26,79.6 c8.5,48.5,54.8,81,103.3,72.5c48.5-8.5,81-54.8,72.5-103.3c-5.8-33.1-29.3-59.9-61.4-69.9c-2.4-0.7-3.7-3.2-2.9-5.6 c0.7-2.4,3.2-3.7,5.6-2.9c35.3,11,61.2,40.4,67.5,76.8c9.3,53.3-26.5,104.3-79.8,113.6C109.4,193.1,103.7,193.5,98.1,193.5 L98.1,193.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFtm);
export default __webpack_public_path__ + "static/media/logo_ftm.63a2f257277fc9d5729058cc5e1aed97.svg";
export { ForwardRef as ReactComponent };